import React, { Component, PropsWithChildren } from 'react';
import i18next from 'i18next';
export class ErrorBoundary extends Component<
  PropsWithChildren<Record<string, unknown>>
> {
  state: { hasError: boolean } = { hasError: false };

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    return this.state.hasError ? (
      <p>{i18next.t('The application is temporarily unavailable')}</p>
    ) : (
      this.props.children
    );
  }
}

// import React, { Component, PropsWithChildren } from 'react';
// import { withTranslation, WithTranslation } from 'react-i18next';

// type ErrorBoundaryProps = PropsWithChildren<Record<string, unknown>> & WithTranslation;

// class ErrorBoundary extends Component<ErrorBoundaryProps, { hasError: boolean }> {
//   state: { hasError: boolean } = { hasError: false };

//   componentDidCatch() {
//     this.setState({ hasError: true });
//   }

//   render() {
//     const { t } = this.props;
//     return this.state.hasError ? (
//       <p>{t('The application is temporarily unavailable')}</p>
//     ) : (
//       this.props.children
//     );
//   }
// }

// export const TranslatedErrorBoundary = withTranslation()(ErrorBoundary);
// export default TranslatedErrorBoundary;
